import React, { useEffect, useRef, useState } from 'react';
import { Avatar, Tooltip } from 'antd';
import './styles.css';
import chevronLeft from "../Assets/layout/newFilledIcons/chevron-double-left.svg";
import bellIcon from "../Assets/layout/newFilledIcons/bell.svg";
import userIcon from '../Assets/layout/newFilledIcons/user-accout.svg';
import userIconSettings from '../Assets/layout/newFilledIcons/user-account-settings.svg';
import logoutIcon from '../Assets/layout/newFilledIcons/user-logout-red.svg';
import UserAvatar from 'components/userAvatar';
import { Api } from 'services';

const ProfileMenu = ({ user, userDetails, notificationCount, onLogout, onProfileClick, onNotificationClick, showProfileMenu, collapsed, isVisible, setIsVisible, handleMouseLeave }) => {

  const nameRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (nameRef.current) {
      setShowTooltip(nameRef.current.scrollWidth > nameRef.current.clientWidth);
    }
  }, [user.name]);

  const nameElement = (
    <div
      ref={nameRef}
      className="user-name"
      style={{
        maxWidth: "150px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      {user.name}
    </div>
  );

  return (
    <div
      className={`profile-menu ${collapsed ? "" : showProfileMenu ? "profile-menu-enter" : "profile-menu-exit"
        }`} style={{ zIndex: 1000 }}
    >
      {/* Profile Section */}
      <div className="profile-section" style={{ marginBottom: -10 }}>
        <UserAvatar
          fromProfileMenu={true}
          size="5vmin"
          shape="circle"
          name={user.name}
          img={user.image == "default.png" ? "" : `${Api._s3_url}${user.image}`}
          backgroundColor={userDetails?.backgroundColor || user?.backgroundColor}
          textColor={userDetails?.textColor || user?.textColor} />
        {showTooltip ? (
          <Tooltip title={user.name} placement="top">
            {nameElement}
          </Tooltip>
        ) : (
          nameElement
        )}
      </div>

      {/* Action Buttons */}
      <div className="action-buttons">
        {/* Notification Button */}
        <Tooltip title="Notifications" mouseEnterDelay={0.6}>
          <div className="action-button" onClick={onNotificationClick}>
            <div className="button-content">
              <img src={bellIcon} alt="Notifications" className="icon" />
              {(notificationCount > 0 || notificationCount == '9+') && <span className="badge">{notificationCount}</span>}
            </div>
          </div>
        </Tooltip>

        {/* Profile Button */}
        <Tooltip title={user?.privilage?.includes("SuperAdmin") || user?.privilage?.includes("Admin") ? 'Account settings' : 'Account'} mouseEnterDelay={0.6}>
          <div className="action-button" onClick={onProfileClick}>
            <div className="button-content">
              <img
                src={
                  user?.privilage?.includes("SuperAdmin") || user?.privilage?.includes("Admin")
                    ? userIconSettings
                    : userIcon
                }
                alt="Profile"
                className="icon"
              />
            </div>
          </div>
        </Tooltip>

        {/* Logout Button */}
        <Tooltip title="Logout" mouseEnterDelay={0.6}>
          <div className="action-button" onClick={onLogout}>
            <div className="button-content">
              <img src={logoutIcon} alt="Logout" className="icon" />
            </div>
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

export default ProfileMenu;